import React, {useContext, useEffect} from "react";
import classNames from "classnames";
import {PlusOutlined} from "@ant-design/icons";
import styles from '../../../index.module.less'
import ChooseTagModal from "@/components/ChooseTagModal";
import {useSetState} from "ahooks";
import ClueDetailContext from "../clueDetailContext.ts";
import {getTagsByClueId} from "@/services/saleOpServices.ts";
import {getTagTreeByType} from "@/services/customerServices.ts";
import {Empty, Flex, Spin, Tag} from "antd";
import {callDataAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";
import {useAtom} from "jotai";

const colorList = [
  {
    borderColor: 'rgba(250, 96, 80, 1)',
    fontColor: 'rgba(242, 90, 10, 1)',
  },
  {
    borderColor: 'rgba(0, 100, 255, 1)',
    fontColor: 'rgba(0, 100, 255, 1)',
  },
  {
    borderColor: 'rgba(245, 147, 0, 1)',
    fontColor: 'rgba(245, 147, 0, 1)',
  },
  {
    borderColor: 'rgba(112, 163, 16, 1)',
    fontColor: 'rgba(112, 163, 16, 1)',
  },
]

const Portrait = () => {
  const {clueId, isFreePhone} = useContext(ClueDetailContext)
  const [callData] = useAtom(callDataAtom)

  const [state, setState] = useSetState<any>({
    open: false,
    loading: false,
    tags: [], // 详情展示
    tagList: [], // 添加时弹窗
  })

  useEffect(() => {
    clueId && getInfo()
    fetchTagTreeByType()
  }, [clueId]);

  const getInfo = () => {
    setState({loading: true})
    getTagsByClueId(clueId).then(res => {
      const tagMap = new Map();
      res.forEach(tag => {
        if (Array.isArray(tag.tags)) {
          tag.tags.forEach(item => {
            if (!tagMap.has(item.tagId)) {
              tagMap.set(item.tagId, item);
            }
          });
        }
      });
      const tags = Array.from(tagMap.values());
      setState({ tags });
    }).finally(() => setState({loading: false}));
  }

  // 客户标签
  const fetchTagTreeByType = async () => {
    try {
      const res: any = await getTagTreeByType('custom');
      const obj = {}
      if (res?.records) {
        const tagList: any = [];
        // 一级分类
        res?.records?.forEach(item1 => {
          // 二级
          if (item1?.children && item1?.children?.length) {
            // 第二级为标签
            if (item1?.children?.[0]?.object.groupTag === 'tag' && !obj[item1?.id]) {
              obj[item1?.id] = true
              tagList.push({
                key: item1?.id,
                title: item1.label,
                // 二级分类下标签
                tags: item1?.children?.map(tag => ({description: tag?.label, key: tag?.id}))
              })
            }
            item1?.children.forEach(item2 => {
              // 三级分类
              if (item2?.children && item2?.children?.length) {
                // 第三级为标签
                if (item2?.children?.[0]?.object.groupTag === 'tag' && !obj[item2?.id]) {
                  obj[item2?.id] = true
                  tagList.push({
                    key: item2?.id,
                    title: item1.label + ' / ' + item2?.label,
                    // 二级分类下标签
                    tags: item2?.children?.map(tag => ({description: tag?.label, key: tag?.id}))
                  })
                }
                item2?.children.forEach(item3 => {
                  if (item3?.children && item3?.children?.length) {
                    tagList.push({
                      key: item3?.id,
                      title: item1.label + ' / ' + item2?.label + ' / ' + item3?.label,
                      // 三级分类下标签
                      tags: item3?.children?.map(tag => ({description: tag?.label, key: tag?.id}))
                    })
                  }
                })
              }
            })
          }
        });
        setState({tagList});
      }
    } catch (err) {
      console.log(err);
    }
  }

  const addTag = () => {
    return <span className={isFreePhone ? styles.tagsDisabled : styles.tags}
                 onClick={() => {
                   !isFreePhone && setState({open: true})
                 }}><PlusOutlined style={{marginRight: 5}}/>标签</span>
  }

  return <div>
      <div className={classNames([styles.customerTagBoxScroll, styles.mt10, callData.callLine !== 'HELI' ? styles.customerTagBoxScrollMax : styles.customerTagBoxScrollMaxExpand])}>
        <Spin spinning={state.loading}>
          {(state.tags.length > 0 && !state.loading) ?
              <Flex gap={10} wrap>
                {state.tags?.map((item, index) => <span
                    key={item.tagId}
                    className={styles.tags}
                    style={{
                      border: `1px solid ${colorList[index % 4]?.borderColor}`,
                      color: colorList[index % 4]?.fontColor,
                    }}
                >
            {item?.tagName}
          </span>)}
                {addTag()}
              </Flex> : <>
                {addTag()}
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
              </>}
        </Spin>
      </div>

    {state.open && <ChooseTagModal reload={() => getInfo()}
                                   tagList={state.tags}
                                   list={state.tagList}
                                   editId={clueId}
                                   open={state.open}
                                   onClose={() => setState({open: false})}/>}
  </div>
}

export default Portrait